import { styled } from "@mui/material/styles";
import TableRow from "@mui/material/TableRow";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: theme.palette.action.disabled,
  },
  "&:hover": {
    backgroundColor: theme.palette.action.selected,
  },
}));

export default StyledTableRow;
